import ExcelJS from "exceljs";

export const generateOrderExcelTemp = async (warehouses) => {
  try {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Products");

    const warehouse = warehouses?.[0]?.warehouse?.code ?? "";

    const data = [
      {
        "Unique Identifier": {
          "Reference / Order Id": "Order-001",
          Warehouse: warehouse,
        },
        "Recipient Information": {
          "Recipient Name": "Emily Johnson",
          "Recipient Phone": "+1 416-555-7890",
          "Recipient Email": "emily.johnson@example.ca",
          "Recipient Address": "123 Bloor Street West",
          "Recipient Country": "Canada",
          "Recipient City": "Toronto",
          "Recipient State": "Ontario",
          "Recipient Zip": "M5S 1N5",
        },
        "Product 1": {
          "Product 1 Name": "Smartwatch",
          "Product 1 Image": "https://example.com/images/smartwatch.jpg",
          "Product 1 Sku": "SMW-5001",
          "Product 1 Length": "10",
          "Product 1 Width": "8",
          "Product 1 Height": "5",
          "Product 1 Weight": "0.4",
          "Product 1 Unit": "Metric",
          "Product 1 Qty": "3",
        },
      },
      {
        "Unique Identifier": {
          "Reference / Order Id": "Order-002",
          Warehouse: warehouse,
        },
        "Recipient Information": {
          "Recipient Name": "Michael Lee",
          "Recipient Phone": "+1 604-777-8888",
          "Recipient Email": "michael.lee@example.com",
          "Recipient Address": "789 Granville St",
          "Recipient Country": "Canada",
          "Recipient City": "Vancouver",
          "Recipient State": "British Columbia",
          "Recipient Zip": "V6Z 1K7",
        },
        "Product 1": {
          "Product 1 Name": "Laptop Bag",
          "Product 1 Image": "https://example.com/images/laptop-bag.jpg",
          "Product 1 Sku": "LBG-3021",
          "Product 1 Length": "40",
          "Product 1 Width": "30",
          "Product 1 Height": "10",
          "Product 1 Weight": "1.0",
          "Product 1 Unit": "Imperial",
          "Product 1 Qty": "1",
        },
        "Product 2": {
          "Product 2 Name": "Wireless Keyboard",
          "Product 2 Image": "https://example.com/images/keyboard.jpg",
          "Product 2 Sku": "KBW-1102",
          "Product 2 Length": "45",
          "Product 2 Width": "15",
          "Product 2 Height": "3",
          "Product 2 Weight": "0.8",
          "Product 2 Unit": "Imperial",
          "Product 2 Qty": "2",
        },
        "Product 3": {
          "Product 3 Name": "Smartwatch",
          "Product 3 Image": "https://example.com/images/smartwatch.jpg",
          "Product 3 Sku": "SMW-5001",
          "Product 3 Length": "10",
          "Product 3 Width": "8",
          "Product 3 Height": "5",
          "Product 3 Weight": "0.4",
          "Product 3 Unit": "Imperial",
          "Product 3 Qty": "3",
        },
      },
    ];

    const flattenHeaders = {};
    data.forEach((order) => {
      Object.entries(order).forEach(([mainKey, group]) => {
        if (!flattenHeaders[mainKey]) flattenHeaders[mainKey] = new Set();
        Object.keys(group).forEach((subKey) =>
          flattenHeaders[mainKey].add(subKey)
        );
      });
    });

    const headers = Object.keys(flattenHeaders);
    const subheaders = headers.map((key) => Array.from(flattenHeaders[key]));

    const headerStyle = {
      font: { bold: true, color: { argb: "FFFFFF" } },
      fill: { type: "pattern", pattern: "solid", fgColor: { argb: "3498db" } },
      alignment: { horizontal: "center", vertical: "middle" },
      border: {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      },
    };

    const subheaderStyle = {
      fill: { type: "pattern", pattern: "solid", fgColor: { argb: "2ecc71" } },
      alignment: { horizontal: "center", vertical: "middle", wrapText: true },
      border: {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      },
    };

    let colIndex = 1;
    headers.forEach((header, index) => {
      const subheaderCount = subheaders[index].length;

      if (subheaderCount > 1) {
        worksheet.mergeCells(1, colIndex, 1, colIndex + subheaderCount - 1);
      }

      worksheet.getCell(1, colIndex).value = header;
      worksheet.getCell(1, colIndex).style = headerStyle;

      subheaders[index].forEach((sub, subIdx) => {
        const cell = worksheet.getCell(2, colIndex + subIdx);
        cell.value = sub;
        cell.style = subheaderStyle;
      });

      colIndex += subheaderCount;
    });

    data.forEach((order, orderIdx) => {
      let col = 1;
      headers.forEach((section, hIdx) => {
        subheaders[hIdx].forEach((sub) => {
          const val = order?.[section]?.[sub] || "";
          const cell = worksheet.getCell(orderIdx + 3, col); // +3 avoids empty row
          cell.value = val;
          cell.alignment = {
            horizontal: "center",
            vertical: "middle",
            wrapText: true,
          };
          worksheet.getColumn(col).width = Math.max(15, sub.length + 2);
          col++;
        });
      });
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "OrderExcelTemplate.xlsx";
    a.click();
  } catch (error) {
    console.log("Excel generation error:", error);
  }
};
